<template>
  <div class="page-content--bgf7">
    <section class="au-breadcrumb2">
      <div class="container m-b-60">
        <v-tabs
          v-model="tab"
        >
          <v-tab>
            Auto EPG
          </v-tab>
          <v-tab>
            Dummy EPG
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <div class="row">
              <div class="col-md-12">
                <v-card>
                  <div
                    class="col-md-12 links"
                    style="background-color: #eee"
                  >
                    <i class="fa fa-link m-r-5 m-l-5" />XMLTV URL:
                    <a
                      v-if="!loading"
                      :href="channel.xmltv.resultURLAuto"
                      target="_blank"
                    >
                      {{ channel.xmltv.resultURLAuto || 'N/A' }}
                    </a>
                    <i
                      v-if="channel.xmltv.resultURLAuto"
                      class="zmdi zmdi-copy m-l-10 pointer"
                      @click="handleCopy(channel.xmltv.resultURLAuto)"
                    />
                  </div>
                </v-card>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 p-b-0">
                <a
                  href="#"
                  @click.prevent="prev3Days()"
                >
                  <i class="zmdi zmdi-long-arrow-left p-r-5" />
                  prev 3 days
                </a>
              </div>
              <div class="col-md-6 p-b-0 text-right">
                <a
                  href="#"
                  @click.prevent="next3Days()"
                >
                  next 3 days
                  <i class="zmdi zmdi-long-arrow-right p-r-5" />
                </a>
              </div>
            </div>
            <div class="row">
              <div
                v-for="day in days"
                :key="day.start"
                class="col-md-4 p-t-0"
              >
                <v-card>
                  <table class="table table-bordered table-sm table-epg">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          colspan="2"
                          :class="{ 'primary--text': day.current }"
                          class="text-center"
                        >
                          {{ moment(day.start * 1000).utc().format('dddd, D MMMM') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(event, i) in day.events"
                        :key="'event'+i"
                        :class="{'current-event': currentEvent && event.id === currentEvent.id}"
                      >
                        <td
                          style="width: 120px !important;"
                          class="p-l-10"
                        >
                          {{ moment(event.start).format('HH:mm') }} -
                          {{ moment(event.end).format('HH:mm') }}
                        </td>
                        <td class="p-l-10">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="on"
                              >
                                {{ event.program.name | truncate(75) }}
                              </span>
                            </template>
                            {{ event.program.name }}
                          </v-tooltip>
                          <v-progress-linear
                            v-if="currentEvent && event.id === currentEvent.id"
                            :value="playedProgress"
                            color="blue lighten-2"
                            class="ma-0 pa-0"
                            height="5"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-card>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="row">
              <div class="col-md-12 p-t-30">
                <draggable
                  :list="dummyEPGPrograms"
                  v-bind="{animation: 200}"
                  handle=".handle"
                >
                  <div
                    v-for="(program, i) in dummyEPGPrograms"
                    :key="i"
                    class="row"
                  >
                    <div class="col-md-1 p-b-0 p-t-0 p-l-30">
                      <i class="fa fa-align-justify handle p-r-10" />
                    </div>
                    <div class="col-md-4 p-b-0 p-t-0">
                      <v-text-field
                        v-model="program.name"
                        outlined
                        dense
                        label="Episode Title"
                      />
                    </div>
                    <div class="col-md-3 p-b-0 p-t-0">
                      <v-text-field
                        v-model="program.repeat"
                        outlined
                        type="number"
                        dense
                        label="Repeat Count"
                      />
                    </div>
                    <div class="col-md-3 p-b-0 p-t-0">
                      <v-text-field
                        v-model="program.duration"
                        outlined
                        type="number"
                        dense
                        suffix="min"
                        label="Duration"
                      />
                    </div>
                    <div class="col-md-1 p-b-0 p-t-0 p-r-30">
                      <v-btn
                        text
                        icon
                        @click="deleteDummyProgram(i)"
                      >
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </draggable>
              </div>
              <div class="row">
                <div class="col-md-6 p-t-0 p-b-0 text-left p-l-30">
                  <v-btn
                    class="m-l-10"
                    color="primary"
                    @click="addDummyProgram()"
                  >
                    <i class="zmdi zmdi-plus p-r-5" />
                    add
                  </v-btn>
                </div>
                <div class="col-md-6 p-t-0 p-b-0 text-right p-r-30">
                  <v-btn
                    class="m-r-20"
                    :loading="isSaving"
                    :disabled="!isDummyEPGFormValid"
                    color="success"
                    @click="saveDummyEPG()"
                  >
                    Save
                    <v-icon right>
                      mdi-content-save
                    </v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 p-t-20 p-b-0">
                <v-card>
                  <div
                    class="col-md-12 links"
                    style="background-color: #eee"
                  >
                    <i class="fa fa-link m-r-5 m-l-5" />XMLTV URL:
                    <a
                      v-if="!loading"
                      :href="channel.xmltv.resultURLCustom"
                      target="_blank"
                    >
                      {{ channel.xmltv.resultURLCustom || 'N/A' }}
                    </a>
                    <i
                      v-if="channel.xmltv.resultURLCustom"
                      class="zmdi zmdi-copy m-l-10 pointer"
                      @click="handleCopy(channel.xmltv.resultURLCustom)"
                    />
                  </div>
                </v-card>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </section>
  </div>
</template>

<script>
  import moment from 'moment-timezone'
  import { processChannel, processProgram2, processDummyEPG } from '@/store/converters'
  import { setClipboard } from '@/helpers/utils'
  import draggable from 'vuedraggable'

  export default {
    components: {
      draggable,
    },
    data () {
      return {
        tab: 0,
        channel: {
          id: 0,
          name: '',
          timezone: {},
          xmltv: {},
        },
        dummyEPGPrograms: [],
        currentT: null,
        currentTz: null,
        currentEvent: null,
        tzOffset: 0,
        allEvents: [],
        remaining: '',
        played: '',
        polling: null,
        days: [],
        daysOffset: 0,
        epgEvents: [],
        currentUnixTime: moment().utc().unix() * 1000,
        isSaving: false,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      playedProgress () {
        if (!this.currentEvent) return 0
        const eventDuration = this.currentEvent.endOriginal - this.currentEvent.startOriginal
        // eslint-disable-next-line no-mixed-operators
        return (this.currentUnixTime - this.currentEvent.startOriginal) * 100 / eventDuration
      },
      isDummyEPGFormValid () {
        for (let i = 0; i < this.dummyEPGPrograms.length; i += 1) {
          const p = this.dummyEPGPrograms[i]
          if (p.name === '' || p.repeat < 1 || p.duration < 1) {
            return false
          }
        }
        return true
      },
    },
    mounted () {
      this.updateTime()
      this.updateTimer()
    },
    created () {
      const channelId = this.$route.params.id
      this.channel.id = channelId

      this.getChannelInfo(channelId)

      this.currentT = moment().unix()
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      getChannelInfo (id) {
        this.$store.commit('setPageLoader')

        const args = {
          ids: id,
          expand: 'timezone,xmltv,dummy_epg',
        }
        const channelReq = this.$store.dispatch('channels', args)

        return Promise.all([channelReq])
          .then((res) => {
            const channels = res[0]
            this.channel = processChannel(channels[0])
            this.dummyEPGPrograms = this.channel.dummyEPG
            if (!this.dummyEPGPrograms.length) {
              this.addDummyProgram()
            }
            // eslint-disable-next-line max-len
            this.tzOffset = moment.tz(moment.tz.guess()).utcOffset() * 60 * 1000 - moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000
            this.currentTz = moment.utc(moment().unix() * 1000 + moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000).format('MMM D, HH:mm:ss')

            this.getPrograms()
            this.getEPG()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      addDummyProgram () {
        this.dummyEPGPrograms.push({
          id: 0, name: '', repeat: 1, duration: 30,
        })
      },
      deleteDummyProgram (idx) {
        this.dummyEPGPrograms.splice(idx, 1)
      },
      getEPG () {
        const offset = moment.tz(this.channel.timezone.name).utcOffset() * 60
        const daysOffset = 3 * 24 * 3600 * this.daysOffset

        this.days = []

        const today = moment.utc(moment().utc().unix() * 1000 + offset * 1000).startOf('day')
        const yesterday = today.clone().subtract(1, 'days')
        const tomorrow = today.clone().add(1, 'days')
        this.days.push({
          start: moment(`${yesterday.format('YYYY-MM-DD')}T00:00:00Z`).utc().unix() - offset + daysOffset,
          end: moment(`${yesterday.format('YYYY-MM-DD')}T23:59:59Z`).utc().unix() - offset + daysOffset,
          events: [],
        })

        const middleDay = {
          start: moment(`${today.format('YYYY-MM-DD')}T00:00:00Z`).utc().unix() - offset + daysOffset,
          end: moment(`${today.format('YYYY-MM-DD')}T23:59:59Z`).utc().unix() - offset + daysOffset,
          events: [],
        }
        if (daysOffset === 0) {
          middleDay.current = 1
        }
        this.days.push(middleDay)

        this.days.push({
          start: moment(`${tomorrow.format('YYYY-MM-DD')}T00:00:00Z`).utc().unix() - offset + daysOffset,
          end: moment(`${tomorrow.format('YYYY-MM-DD')}T23:59:59Z`).utc().unix() - offset + daysOffset,
          events: [],
        })

        this.getEPGPrograms()
      },
      updateTime () {
        this.polling = setInterval(() => {
          this.currentUnixTime = moment().utc().unix() * 1000
          this.currentTz = moment.utc(moment().unix() * 1000 + moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000).format('MMM D, HH:mm:ss')
          this.findCurrentEvent()

          const args = {
            ids: this.channel.id,
            expand: 'xmltv',
          }
          const channelReq = this.$store.dispatch('channels', args)
          Promise.all([channelReq])
            .then((res) => {
              const channels = res[0]
              const channel = processChannel(channels[0])
              this.channel.xmltv.resultURLCustom = channel.xmltv.resultURLCustom
            })
            .catch((errorMsg) => {
              console.log(errorMsg)
            })
        }, 10 * 1000)
      },
      prev3Days () {
        this.daysOffset -= 1
        this.getEPG()
      },
      next3Days () {
        this.daysOffset += 1
        this.getEPG()
      },
      updateTimer () {
        setInterval(() => {
          const now = Date.now()
          if (this.currentEvent) {
            const remaining = this.currentEvent.endOriginal - now
            const played = now - this.currentEvent.startOriginal
            this.played = played > 0 ? moment.utc(played).format('HH:mm:ss.SSS') : ''
            if (remaining <= 0) {
              this.findCurrentEvent()
            }
            this.remaining = remaining > 0 ? moment.utc(remaining).format('HH:mm:ss.SSS') : ''
          }
        }, 100)
      },
      findCurrentEvent () {
        if (!this.channel.timezone.name) return
        const t = moment().utc().unix() * 1000
        this.currentEvent = null
        for (let j = 0; j < this.allEvents.length; j += 1) {
          const event = this.allEvents[j]
          if (t >= event.startOriginal && t <= event.endOriginal) {
            this.currentEvent = event
            break
          }
        }
        if (!this.currentEvent) {
        // this.toolbarCurrentEvent();
        }
      },
      toolbarCurrentEvent () {
        const params = {
          channel_id: this.channel.id,
        }
        this.$store.dispatch('programs/getCurrentProgram', params)
          .then((program) => {
            if (program) {
              this.currentEvent = this.processProgram(program)
            }
          })
          .catch((errorMsg) => {
            // eslint-disable-next-line no-console
            console.log('getCurrentProgram', errorMsg)
          })
      },
      processEvent (p) {
        const program = processProgram2(p)
        const start = moment(program.startTime).utc().unix() * 1000
        const end = moment(program.endTime).utc().unix() * 1000

        return {
          id: program.id,
          color: '#eceff1',
          start: start - this.tzOffset,
          end: end - this.tzOffset,
          startOriginal: start,
          endOriginal: end,
          program,
          fixed: p.fixed,
          timed: true,
          t: true,
        }
      },
      getPrograms () {
        this.$store.commit('setPageLoader')

        const params = {
          'end_time[gt]': `${moment().utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
          'start_time[lt]': `${moment().add(2, 'days').utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
          'channel.id[eq]': this.channel.id,
          $expand: 'items',
        }
        this.$store.dispatch('programs2', params)
          .then((programs) => {
            this.allEvents = programs.map((p) => this.processEvent(p))
            this.findCurrentEvent()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      getEPGPrograms () {
        if (!this.days.length) return

        const params = {
          'end_time[gt]': `${moment(this.days[0].start * 1000).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
          'start_time[lt]': `${moment(this.days[this.days.length - 1].end * 1000).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
          'channel.id[eq]': this.channel.id,
        }

        this.$store.dispatch('programs2', params)
          .then((programs) => {
            this.epgEvents = programs.map((p) => this.processEvent(p))
            for (let i = 0; i < this.days.length; i += 1) {
              this.calcDay(this.days[i])
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      calcDay (day) {
        const dayStart = day.start * 1000
        const dayEnd = day.end * 1000

        // eslint-disable-next-line no-param-reassign
        day.events = []

        // eslint-disable-next-line no-nested-ternary,max-len
        this.epgEvents.sort((a, b) => ((a.startOriginal > b.startOriginal) ? 1 : ((b.startOriginal > a.startOriginal) ? -1 : 0)))

        const events = []

        for (let i = 0; i < this.epgEvents.length; i += 1) {
          const event = this.epgEvents[i]
          if ((event.startOriginal > dayStart && event.startOriginal < dayEnd) ||
            (event.endOriginal > dayStart && event.endOriginal < dayEnd)) {
            events.push(event)
          }
        }

        // eslint-disable-next-line no-param-reassign
        day.totalEvents = events.length

        const gapEvents = []
        if (events.length > 0) {
          for (let i = 0; i < events.length; i += 1) {
            const event = events[i]
            if (i !== events.length - 1) {
              if (i === 0 && event.startOriginal - dayStart > 60) {
                gapEvents.push({
                  program: {
                    name: '---',
                    subType: '',
                  },
                  start: dayStart - this.tzOffset,
                  end: event.start,
                })
              }
              if (events[i + 1].startOriginal - event.endOriginal > 60) {
                gapEvents.push({
                  program: {
                    name: '---',
                    subType: '',
                  },
                  start: event.end,
                  end: events[i + 1].start,
                })
              }
            } else if (dayEnd - event.endOriginal > 60) {
              gapEvents.push({
                program: {
                  name: '---',
                  subType: '',
                },
                start: event.end,
                end: dayEnd - this.tzOffset,
              })
            }
          }
        } else {
          gapEvents.push({
            program: {
              name: '---',
              subType: '',
            },
            start: dayStart - this.tzOffset,
            end: dayEnd - this.tzOffset,
          })
        }

        const allEvents = events.concat(gapEvents)
        // eslint-disable-next-line no-nested-ternary
        allEvents.sort((a, b) => ((a.start > b.start) ? 1 : ((b.start > a.start) ? -1 : 0)))
        // eslint-disable-next-line no-param-reassign
        day.events = allEvents
      },
      handleCopy (text) {
        setClipboard(text)
        this.$store.commit('showSnackbar', {
          text: 'URL has been copied',
          timeout: 6000,
          color: 'success',
        })
      },
      getXMLTV () {
        return this.$store.dispatch('programs/getXMLTV')
          .then((file) => {
            // eslint-disable-next-line no-console
            console.log(file)
          })
          .catch((errorMsg) => {
            // eslint-disable-next-line no-console
            console.log('getXMLTV', errorMsg)
          })
      },
      saveDummyEPG () {
        if (!this.isDummyEPGFormValid) return
        this.isSaving = true

        this.$store.commit('setPageLoader')

        const dummyEPG = this.dummyEPGPrograms.map((p) => processDummyEPG(p))
        const dummyEPGUpdateReq = this.$store.dispatch('updateDummyEPG', { channelId: this.channel.id, epg: dummyEPG })

        return Promise.all([dummyEPGUpdateReq])
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The EPG has been successfully saved',
              timeout: 3000,
              color: 'success',
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
            this.isSaving = false
          })
      },
    },
  }
</script>

<style>
  .current-event {
    background-color: #E3F2FD;
  }
  .handle {
    float: left;
    padding-top: 8px;
    padding-bottom: 8px;
    cursor: pointer;
  }
</style>
